<app-local-loading-indicator *ngIf="carrierSvc.isLoading$ | async" width="90%" height="100%" applyOverlay="true">
</app-local-loading-indicator>
<app-common-filter [list]="carrierList" textField='Description' [(filter)]="filter" [(isDirty)]="isDirty"
    valueField="Description" identifier="shipment_filter_carrier">
</app-common-filter>